import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import {
  PRE_ACTIVATION_CONFIDENTIALITY_NOTE,
  PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_ACCOUNT_ADMIN,
  PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_RESCHEDULE,
  PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_SINGLE_BRAND,
  PRE_ACTIVATION_SECTION_AGENCY_06_HEADING,
  PRE_ACTIVATION_SUBMIT_BUTTON,
} from "../../../i18n/keysTranslations";
import Button from "../../../components/Buttons/Button";
import CheckboxField from "../components/CheckboxField";
import ReadOnlySectionGrid from "../components/ReadOnlySectionGrid";

const AgencyConfirmationsSection = ({
  control,
  readOnly,
  isSaving = false,
  hasSubmitted = false,
  submitError,
}) => {
  const { t } = useTranslation();
  const submitDisabled = readOnly || isSaving || hasSubmitted;

  return (
    <>
      <Typography
        component="h2"
        sx={{
          fontSize: "18px",
          fontWeight: 800,
          color: "text.primary",
          letterSpacing: "-0.3px",
          lineHeight: 1.3,
          textTransform: "none",
          marginBottom: "20px",
        }}
      >
        {t(PRE_ACTIVATION_SECTION_AGENCY_06_HEADING)}
      </Typography>
      <ReadOnlySectionGrid readOnly={readOnly}>
        <CheckboxField
          name="confirmations.singleBrand"
          label={t(PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_SINGLE_BRAND)}
          control={control}
          readOnly={readOnly}
          required
        />
        <CheckboxField
          name="confirmations.accountAdmin"
          label={t(PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_ACCOUNT_ADMIN)}
          control={control}
          readOnly={readOnly}
          required
        />
        <CheckboxField
          name="confirmations.reschedule"
          label={t(PRE_ACTIVATION_FIELD_AGENCY_CONFIRM_RESCHEDULE)}
          control={control}
          readOnly={readOnly}
          required
        />
      </ReadOnlySectionGrid>

      {readOnly ? null : (
        <>
          {submitError ? (
            <Typography
              role="alert"
              sx={{
                color: "error.main",
                fontSize: "14px",
                textAlign: "center",
                mb: 1,
              }}
            >
              {submitError}
            </Typography>
          ) : null}
          <Button
            type="submit"
            fullWidth
            color="primary"
            disabled={submitDisabled}
            sx={{
              mt: 1,
              py: 1.5,
              fontWeight: 600,
              borderRadius: "9px !important",
            }}
          >
            <Box
              component="span"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.5,
              }}
            >
              {isSaving ? (
                <CircularProgress size={22} sx={{ color: "inherit" }} />
              ) : null}
              <Box component="span">{t(PRE_ACTIVATION_SUBMIT_BUTTON)}</Box>
            </Box>
          </Button>
          <Typography
            component="p"
            variant="body2"
            sx={{
              mt: 2,
              color: "text.secondary",
              textAlign: "center",
            }}
          >
            {t(PRE_ACTIVATION_CONFIDENTIALITY_NOTE)}
          </Typography>
        </>
      )}
    </>
  );
};

export default AgencyConfirmationsSection;
